import { createContext, useState } from "react";

const PendientesContext = createContext();

const PendientesProvider = ({children}) => {
    const [pendientes, setPendientes] = useState([])

    const handlePendientes  =  (arrPendientes) => {

        setPendientes(arrPendientes);
    }

    const data = {pendientes, handlePendientes};

    return (
        <PendientesContext.Provider value={data}>{children}</PendientesContext.Provider>
    )
}

export { PendientesProvider };
export default PendientesContext;